import React from 'react';
import {LayoutChild} from "../../../../palette/Palette";
import {Chart, Series, CommonSeriesSettings, Label, Format, Legend, Export} from 'devextreme-react/chart';
import Alerts from "../../../../palette/Alerts";

function Payments(props) {

    const {payments} = props

    return (
        <>
            {payments?.length > 0 ?
                <LayoutChild percent={100} padding={10}>
                    <Chart id="chart"
                           title="Ingresos por forma de pago"
                           dataSource={payments}
                           style={{padding: 10}}
                    >
                        <CommonSeriesSettings
                            argumentField="month"
                            type="bar"
                            hoverMode="allArgumentPoints"
                            selectionMode="allArgumentPoints"
                        >
                            <Label visible={true}>
                                <Format type="fixedPoint" precision={2}/>
                            </Label>
                        </CommonSeriesSettings>
                        <Series
                            argumentField="month"
                            valueField="Efectivo"
                            name="Efectivo"
                        />
                        <Series
                            valueField="card"
                            name="Tarjeta de credito"
                        />
                        <Legend verticalAlignment="horizontal" horizontalAlignment="center" orientation={'horizontal'}/>
                        <Export enabled={true}/>
                    </Chart>
                </LayoutChild> : <div style={{marginTop: 10, padding: 5}}>
                    <Alerts severity="warning" body={'Aún no tiene viajes concluidos.'}/>
                </div>}
        </>
    )
}

export default Payments